export const formatModalTitle = (title: string): string => {
  let modalWidth = document.querySelector('.ant-modal-confirm')?.clientWidth || 0;

  if (modalWidth === 0) {
      return title;
  }
  if (modalWidth > 416) {
      modalWidth = 416;
  }

  const maxLength = modalWidth - 96;
  const maxCharacters = maxLength * 0.0625;

  const lastPeriodIndex = title.lastIndexOf('。');
  if (lastPeriodIndex === -1) return title;

  const beforePeriod = title.slice(0, lastPeriodIndex + 1);
  const afterPeriod = title.slice(lastPeriodIndex + 1);

  const beforePeriodLines = Math.ceil(beforePeriod.length / maxCharacters);

  if (beforePeriodLines > 1) {
      const remainingSpace = maxCharacters * beforePeriodLines - beforePeriod.length;
      if (afterPeriod.length > remainingSpace) {
          return beforePeriod + '\n' + afterPeriod.trim();
      }
  } else if (beforePeriod.length + afterPeriod.length > maxCharacters) {
      return beforePeriod + '\n' + afterPeriod.trim();
  }

  return title;
};
